{
  "register": "注册",
  "login": "登录",
  "label": {
    "phoneNumber": "手机号",
    "password": "密码",
    "loginPassword": "登录密码",
    "confirmLoginPassword": "确认登录密码",
    "verificationCode": "短信验证码",
    "newPassword": "新密码",
    "confirmNewPassword": "确认新密码",
    "txPassword": "交易密码"
  },
  "placeholder": {
    "phoneNumber": "请输入手机号",
    "password": "请输入密码",
    "loginPassword": "请输入登录密码",
    "confirmLoginPassword": "请再次输入登录密码",
    "verificationCode": "请输入验证码",
    "newPassword": "请输入新密码",
    "confirmNewPassword": "请再次输入新密码"
  },
  "hint": {
    "password": "8个字符以上，需含数字、英文字母（大小写不限）",
    "mismatch": "两个密码不一致，请重新输入",
    "phoneNumberInvalid": "请输入正确的手机号",
    "repeatedRegister": "已有人使用了该手机号，请重新输入",
    "wrongPassword": "密码错误",
    "passwordInvalid": "只能使用字母、数字和常用标点符号"
  },
  "toast": {
    "success": {
      "changeLoginPassword": "登录密码修改成功",
      "sendVerificationCode": "验证码发送成功"
    },
    "error": {
      "loginFailed": "手机号或密码错误",
      "loginRateLimited": "登录尝试次数过多，请 15 分钟后再试",
      "otpFailed": "验证码错误，请重新输入或重新获取",
      "otpVerificationRateLimited": "验证码尝试次数过多，请 15 分钟后再试",
      "sendVerificationCode": "验证码发送失败",
      "sendVerificationCodeTooFast": "验证码请求过快，请 60 秒后重新获取",
      "sendVerificationCodeQuotaReached": "验证码请求次数已达上限，请 15 分钟后重试",
      "smsServiceUnavailable": "短信服务暂时不可用，请稍后重试",
      "notRegisteredPhoneNumber": "手机号未注册",
      "serverError": "服务器异常，请稍候重试。",
      "networkError": "网络异常，请稍后重试。",
      "timeoutError": "操作超时，请稍后再试。",
      "changeLoginPasswordFailed": "登录密码修改失败，请稍后重试",
      "invalidOperation": "无法执行此操作，请刷新页面后重试。",
      "invalidOperationHint": "无法执行此操作",
      "noAccess": "IP不合法"
    }
  },
  "country": {
    "China": "中国",
    "Taiwan": "台湾",
    "Hong Kong": "香港",
    "Thailand": "泰国",
    "United States": "美国",
    "Russia": "俄罗斯",
    "Netherlands": "荷兰",
    "France": "法国",
    "Cyprus": "塞浦路斯",
    "United Kingdom": "英国",
    "Poland": "波兰",
    "Malaysia": "马来西亚",
    "Australia": "澳大利亚",
    "Indonesia": "印尼",
    "Philippines": "菲律宾",
    "Singapore": "新加坡",
    "Japan": "日本",
    "Korea": "韩国",
    "Macao": "澳门",
    "Cambodia": "柬埔寨",
    "Turkey": "土耳其",
    "Myanmar": "缅甸",
    "United Arab Emirates": "阿联酋",
    "Israel": "以色列"
  },
  "countryOrRegion": "国家/地区",
  "forgetPassword": "忘记密码？",
  "clearPhoneNumber": "清除手机号",
  "otpDeliveryNotice": "短信可能稍有延迟，请以收到的最新一条为准",
  "noAccount": "还没有帐号？<0>注册<0/>",
  "haveAccount": "您已经有帐户了吗？<0>登录</0>",
  "getVerificationCode": "获取验证码",
  "retryAfterSeconds": "{{count}} 秒",
  "loginExpired": "登录已过期",
  "continue": "继续",
  "complete": "完成",
  "confirm": "确认",
  "registerSuccess": "注册成功",
  "retrievePassword": "找回密码",
  "changeLoginPassword": "修改登录密码",
  "safetyVerification": "安全验证"
}
